import React from "react";
import ErrorScreen, { reportStatusFrom } from "./ErrorScreen";
import { reportError } from "src/lib/errorReporter";
import { markErrorHandled } from "src/lib/globalErrors";

/*
 * Last-resort boundary around the whole app (route render errors are normally caught first
 * by the router's errorElement, RouteError). Shows the full-screen error and reports it.
 * It lives outside the router, so navigation uses full page loads.
 */
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, reportStatus: "sending", reportId: undefined };
    this.mounted = false;
  }

  static getDerivedStateFromError(error) {
    markErrorHandled(error);
    return { error, reportStatus: "sending", reportId: undefined };
  }

  componentDidMount() {
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  componentDidCatch(error, info) {
    reportError(error, { source: "boundary", componentStack: info?.componentStack }).then((result) => {
      if (this.mounted && this.state.error === error) {
        this.setState({ reportStatus: reportStatusFrom(result), reportId: result.reportId });
      }
    });
  }

  render() {
    const { error, reportStatus, reportId } = this.state;
    if (!error) return this.props.children;

    return (
      <ErrorScreen
        error={error}
        reportStatus={reportStatus}
        reference={reportId || error?.requestId}
        onReload={() => window.location.reload()}
        onHome={() => window.location.assign("/index")}
      />
    );
  }
}
